import { Link } from 'react-router-dom';

export default function NotFound(){    
return(
<div className="page-wrapper">
  <div className="error-area">
    <div className="error-content text-center">
      <div className="error-num">
        404
        <div className="error-num__clip">404</div>
      </div>
      <h2>Page Not Found</h2>
      <Link to={'/'} className="cmn-btn mt-4">
        Go back to Home
      </Link>
    </div>
  </div>
</div>

);
}